/* eslint-disable camelcase */

import EzController from 'controllers/ez-base-controller';
import {
  triggerCustomEvent,
  parseTemplate,
} from 'lib/helpers';
import { ajaxGet } from 'lib/ajax-helpers';
import events from 'lib/events';
import MediaMatcher from 'lib/media-matcher';

const mediaMatcher = new MediaMatcher();

export default class ThumbnailContribInfoController extends EzController {
  static targets = [
    'contribInfoTemplate',
    'missingAvatarSvg',
    'contribThumbnails',
  ];

  connect() {
    if (this.hasContribInfoTemplateTarget && this.contributorsIds.length) this.setupMediaQueries();
    if (this.hasContribThumbnailsTarget) this.setupFollowingThumbnails();

    mediaMatcher.evaluateAll();
    mediaMatcher.addListeners();

    window.addEventListener('setNewThumbnailContributorInfo', this.setNewThumbnailInfo);
  }

  disconnect() {
    mediaMatcher.removeListeners();
    mediaMatcher.clearQueries();

    window.removeEventListener('setNewThumbnailContributorInfo', this.setNewThumbnailInfo);
  }

  setNewThumbnailInfo = () => {
    this.setupContribInfoTooltips();
  }

  setupContribInfoTooltips() {
    ajaxGet('/async_contributors_info',
      (response) => {
        this.contributorsInfo = response.data;
        // this.prefetchImages();
      },
      (error) => {
        console.error(error); // eslint-disable-line no-console
      },
      { params: { contributor_ids: this.contributorsIds, preview_count: 3 } });

    this.tooltipsInitialized = false;

    mediaMatcher.addMediaQuery('(min-width: 1024px)', this.initTooltips);

    mediaMatcher.evaluateAll();
    mediaMatcher.addListeners();
  }

  setupFollowingThumbnails() {
    ajaxGet('/async_contributors_info', (response) => {
      this.contributorsInfo = response.data;

      this.gatherfollowedUsers().forEach((followedUser) => {
        const thisPreviewsWrap = document.querySelector(`[data-user-id="${followedUser}"] [data-target="thumbnail-contributor-info.previewsWrap"]`);
        const previewImageSets = this.contributorsInfo[followedUser].previews;

        let previewsHTML = '';

        previewImageSets.forEach((thumb) => {
          const {
            thumb_src,
            thumb_src_2x,
            resource_path,
            resource_title,
          } = thumb;

          previewsHTML += this.makePreviewThumbHTML(thumb_src, thumb_src_2x, resource_path, resource_title);
        });

        thisPreviewsWrap.innerHTML = previewsHTML;
      });
    },
    (error) => {
      console.error(error); // eslint-disable-line no-console
    },
    { params: { contributor_ids: this.gatherfollowedUsers(), preview_count: 3, sort: 'recent' } });
  }

  get contributorsIds() {
    return JSON.parse(this.contribInfoTemplateTarget.dataset.userIds);
  }

  gatherfollowedUsers() {
    const followedUsers = [];

    this.contribThumbnailsTargets.forEach((followedUser) => {
      followedUsers.push(followedUser.dataset.userId);
    });

    return followedUsers;
  }

  // prefetchImages() {
  //   const avatarImages = Object.values(this.contributorsInfo).map((obj) => obj.contributor_avatar_src);

  //   avatarImages.forEach((src) => {
  //     if (src) (new Image()).src = src;
  //   });

  //   const previewImageSets = Object.values(this.contributorsInfo).map((obj) => obj.previews);

  //   previewImageSets.forEach((previews) => {
  //     previews.forEach((preview) => {
  //       if (preview.thumb_src) (new Image()).src = preview.thumb_src;
  //       if (preview.thumb_src_2x) (new Image()).src = preview.thumb_src_2x;
  //     });
  //   });
  // }

  initTooltips = () => {
    if (!this.tooltipsInitialized) {
      const controller = this;
      const thisGridNameTargets = this.element.querySelectorAll('[data-target="resources-grid.nameTarget"]:not(.is-tipped)');
      const loadingSpinnerHtml = '<div class="ez-spinner ez-spinner--sm ez-spinner--color-mono"></div>';

      import('tippy.js').then((tippyImport) => {
        const tippy = tippyImport.default;

        tippy(thisGridNameTargets, {
          content: loadingSpinnerHtml,
          allowHTML: true,
          animation: 'rising',
          interactive: true,
          appendTo: document.body,
          placement: 'bottom-start',
          theme: 'contrib-info',
          delay: [250, null],
          duration: 0,
          onCreate(instance) {
            instance.popper.classList.add('contributor-info-tooltip');
          },
          onShow(instance) {
            controller.tippyInstance = instance;
            controller.showTooltip();

            instance.popper.addEventListener('mouseleave', controller.stopPreviewVideo);
          },
          onHide(instance) {
            controller.tippyInstance = instance;
            controller.hideTooltip();

            instance.popper.removeEventListener('mouseleave', controller.stopPreviewVideo);
          },
        });

        this.tooltipsInitialized = true;
      });

      thisGridNameTargets.forEach((el) => {
        el.classList.add('is-tipped');
      });
    }
  }

  showTooltip() {
    this.contributorsInfoPolling = setInterval(this.injectTooltipContent, 100);

    this.injectTooltipContent();
  }

  hideTooltip() {
    clearInterval(this.contributorsInfoPolling);

    const tooltipParentLi = this.getParentLi(this.tippyInstance.reference);
    const tooltipProfileInfo = this.getTooltipHeader(this.tippyInstance.popper);

    tooltipParentLi.classList.remove('is-active');
    if (tooltipProfileInfo) tooltipProfileInfo.removeEventListener('click', this.clickThroughToProfile);
  }

  stopPreviewVideo = (event) => {
    const tooltipParentLi = this.getParentLi(this.tippyInstance.reference);

    if (!this.newTargetIsPreview(event.relatedTarget)) {
      tooltipParentLi.classList.remove('is-playing');
    }
  }

  newTargetIsPreview(newTarget) {
    if (!newTarget.hasAttribute('data-target')) return false;
    if (!newTarget.getAttribute('data-target').includes('video-preview.videoWrap')) return false;

    return true;
  }

  injectTooltipContent = () => {
    if (this.contributorsInfo) {
      clearInterval(this.contributorsInfoPolling);

      const templateHTML = this.contribInfoTemplateTarget.innerHTML;
      const parsedContent = this.parseTemplateForContributor(templateHTML);

      setTimeout(() => { // wait a tick to let the parsing happen
        this.initTooltipContent(parsedContent);
      }, 0);
    }
  }

  initTooltipContent(parsedContent) {
    const tooltipContent = this.getTooltipContent(this.tippyInstance.popper);
    const tooltipParentLi = this.getParentLi(this.tippyInstance.reference);

    tooltipContent.innerHTML = parsedContent;

    this.fixAvatar();
    this.loadPreviewThumbs();

    tooltipParentLi.classList.add('is-active');

    const tooltipProfileInfo = this.getTooltipHeader(this.tippyInstance.popper);
    tooltipProfileInfo.addEventListener('click', this.clickThroughToProfile);
  }

  parseTemplateForContributor(templateHTML) {
    // parseTemplate replaces data-href with `url` on item object
    const contribData = this.contributorInfoById;
    contribData.url = contribData.contributor_uploads_path;
    contribData.src = contribData.contributor_avatar_src;

    return parseTemplate(templateHTML, this.contributorInfoById);
  }

  fixAvatar() {
    const tooltipContent = this.getTooltipContent(this.tippyInstance.popper);
    const avatarWrapper = tooltipContent.querySelector('.ez-avatar');
    const avatarTemplate = tooltipContent.querySelector('[data-target="thumbnail-contributor-info.avatarTemplate"]');

    if (this.contributorInfoById.contributor_avatar_src) {
      avatarWrapper.classList.remove('ez-avatar--missing');
      avatarWrapper.innerHTML = avatarTemplate.innerHTML;
    }
  }

  loadPreviewThumbs() {
    const thisPreviews = this.contributorInfoById.previews;
    const thisPreviewsWrap = this.tippyInstance.popper.querySelector('[data-target="thumbnail-contributor-info.previewsWrap"]');

    let previewsHTML = '';

    thisPreviews.forEach((thumb) => {
      const thumbSrc = thumb.thumb_src;
      const thumbSrc2x = thumb.thumb_src_2x;
      const thumbResourcePath = thumb.resource_path;
      const thumbResourceTitle = thumb.resource_title;

      previewsHTML += this.makePreviewThumbHTML(thumbSrc, thumbSrc2x, thumbResourcePath, thumbResourceTitle);
    });

    thisPreviewsWrap.innerHTML = previewsHTML;
  }

  makePreviewThumbHTML(src, src2x, resourcePath, resourceTitle) {
    return `<a href="${resourcePath}" class="ez-resource-grid__item__contrib-info__uploads__thumb">
              <img src="${src}"
                   srcset="${src2x} 2x, ${src} 1x" alt="${resourceTitle}"></a>
              `;
  }

  get contributorInfoById() {
    const contributorId = this.tippyInstance.reference.getAttribute('data-user-id');

    return this.contributorsInfo[contributorId];
  }

  getParentLi(elem) {
    return elem.closest('.ez-resource-thumb');
  }

  clickThroughToProfile = () => {
    triggerCustomEvent(events.resources.grid.contributor_info_profile_click);
  }

  getTooltipHeader(tooltip) {
    return tooltip.querySelector('.tippy-box[data-theme=contrib-info] .contributor-details__contributor');
  }

  getTooltipContent(tooltip) {
    return tooltip.querySelector('.tippy-content');
  }

  setupMediaQueries() {
    mediaMatcher.addMediaQuery('(min-width: 1024px)',
      () => { if (this.contributorsIds.length) this.setupContribInfoTooltips(); });
  }
}
